import React from "react"
import { Dropdown, Input } from "ui"
import Button from "ui/components/Button"
import DatePicker from "ui/components/DatePicker"
import { memoize } from "lodash"
const stringOptions = ["is", "contains", "startsWith", "endsWith"]

/**
 * @see isTrue at the bottom of the file
 */
const filterOptionsForType = {
    autoid: ["is"],
    string: stringOptions,
    long_text: stringOptions,
    lookup: ["is"],
    url: stringOptions,
    date: ["beforeDate", "afterDate", "sameDay"],
    image: ["is"],
    checkbox: ["is"],
    dropdown: ["oneOf"],
    integer: ["equals", "lessThan", "equalsOrLessThan", "greaterThan", "equalsOrGreaterThan"]
}

const labels = {
    equals: "=",
    lessThan: "<",
    equalsOrLessThan: "<=",
    greaterThan: ">",
    equalsOrGreaterThan: ">=",
    is: "=",
    oneOf: "=",
    startsWith: "starts with",
    endsWith: "ends with"

}
const filterText = props => (
    <Input {...props} onChange={event => props.onChange(event.target.value)} value={props.value || ""}/>
)
const filterDate = props => (
    <DatePicker
        {...props}
        onChange={event => {
            props.onChange(event.toISOString())
        }}
    />
)
const nextFilterOptions = {
    is: filterText,
    contains: filterText,
    startsWith: filterText,
    endsWith: filterText,
    equals: filterText,
    greaterThan: filterText,
    lessThan: filterText,
    equalsOrGreaterThan: filterText,
    equalsOrLessThan: filterText,
    beforeDate: filterDate,
    afterDate: filterDate,
    sameDay: filterDate,
    oneOf: ({ field, ...props }) => <Dropdown options={field.options.options} {...props} />,
}

class FieldFilter extends React.Component {
    render() {
        const {
            field: { type, label },
        } = this.props

        const options = filterOptionsForType[type]
        if (!options) {
            throw new Error("Filter type "+type+" doesn't exist, check the file records/components/RecordFilters")
        }
        const selectedOption = this.props.filterOptions.option || options[0]

        return (
            <div className="display-flex" style={{ minWidth: 600 }}>
                {this.props.showLogicalOperator ? (
                    <div style={{ flexBasis: "100px" }}>
                        <Dropdown
                            options={[
                                { label: "AND", value: "AND" } /*, { label: "OR", value: "OR" }*/,
                            ]}
                            value={this.props.filterOptions.operator}
                            onChange={operator =>
                                this.props.onChange({
                                    id: this.props.id,
                                    options: { ...this.props.filterOptions, operator },
                                })
                            }
                        />
                    </div>
                ) : null}
                <div style={{ flexBasis: "200px" }}>
                    <Dropdown value={this.props.field._sid} options={this.props.options} disabled />
                </div>
                <div style={{ flexBasis: "200px" }}>
                    {options.length === -1 ? (
                        <Dropdown
                            options={options.map(value => ({ label: labels[value] || value, value }))}
                            value={options[0]}
                            disabled
                        />
                    ) : (
                        <Dropdown
                            options={options.map(value => ({ label: labels[value] || value, value }))}
                            value={this.props.filterOptions.option}
                            onChange={option =>
                                this.props.onChange({
                                    id: this.props.id,
                                    options: { ...this.props.filterOptions, option },
                                })
                            }
                        />
                    )}
                </div>
                <div style={{ flexBasis: "200px" }}>
                    {selectedOption
                        ? nextFilterOptions[selectedOption]({
                              field: this.props.field,
                              value: this.props.filterOptions.value,
                              onChange: value =>
                                  this.props.onChange({
                                      id: this.props.id,
                                      options: { ...this.props.filterOptions, value },
                                  }),
                          })
                        : null}
                </div>
                <div style={{ flexBasis: "100px" }}>
                    <Button onClick={this.props.delete} size="small">
                        Delete
                    </Button>
                </div>
            </div>
        )
    }
}
export default class ObjectFieldsFilter extends React.Component {
    state = {
        filters: this.props.value || [],
        isAdding: !this.props.value,
    }
    select = id => {
        const field = this.props.object.fields.filter(({ _sid }) => _sid === id)[0]
        this.setState(
            ({ filters }) => ({
                isAdding: false,
                filters: [...filters, { field, options: { operator: "AND" }, _id: Math.random() }],
            }),
            () => {
                this.props.onChange(this.state.filters)
            }
        )
    }
    onChangeField = ({ id, options }) => {
        this.setState(
            ({ filters }) => ({
                isAdding: false,
                filters: filters.map(filter => {
                    if (filter._id !== id) return filter

                    return {
                        ...filter,
                        options,
                    }
                }),
            }),
            () => this.props.onChange(this.state.filters)
        )
    }
    delete = id => {
        this.setState(
            ({ filters }) => ({ filters: filters.filter(({ _id }) => _id !== id) }),
            () => {
                this.props.onChange(this.state.filters)
                if (this.state.filters.length === 0) this.setState({ isAdding: true })
            }
        )
    }
    render() {
        const types = this.props.object.fields.map(({ type, label, _sid }) => ({
            type,
            label,
            value: _sid,
        }))

        return (
            <React.Fragment>
                {this.state.filters.map((filter, index) => (
                    <FieldFilter
                        field={filter.field}
                        filterOptions={filter.options}
                        options={types}
                        showLogicalOperator={index > 0}
                        onChange={this.onChangeField}
                        id={filter._id}
                        delete={() => this.delete(filter._id)}
                    />
                ))}
                {this.state.isAdding ? (
                    <Dropdown options={types} onChange={value => this.select(value)} />
                ) : (
                    <div>
                        <Button onClick={() => this.setState({ isAdding: true })}>add</Button>
                    </div>
                )}
            </React.Fragment>
        )
    }
}

function _processFilter(data, filters) {
    if (!filters) return data
    if (!data) {
        return data
    }
    let workingData = data

    filters.map(filter => {
        workingData = workingData.filter(row => {
            return isTrue(row[filter.field.api_name], filter.options)
        })
    })

    return workingData
}
const map = new WeakMap()
export const processFilter = memoize(_processFilter, (a, b) => {
    if (typeof a === "undefined" || typeof b === "undefined") return Math.random() + 1
    if (!map.has(a)) map.set(a, Math.random())
    if (!map.has(b)) map.set(b, Math.random())

    return map.get(a) + "_" + map.get(b)
})

function isTrue(data, filter) {
    if (typeof filter.value === "undefined") return true
    switch (filter.option) {
        case "is":
            return data === filter.value
        case "oneOf": // currently it's a 'is'
            return data === filter.value
        case "contains":
            return String(data).includes(filter.value)
        case "startsWith":
            return String(data).startsWith(filter.value)
        case "endsWith":
            return String(data).endsWith(filter.value)
        case "equals":
            return data === Number(filter.value)
        case "lessThan":
            return data < filter.value
        case "greaterThan":
            return data > filter.value
        case "equalsOrLessThan":
            return data <= filter.value
        case "equalsOrGreaterThan":
            return data >= filter.value
        default:
            return true
    }
}



// WEBPACK FOOTER //
// ./src/features/records/components/RecordFilters.js